<script lang="ts">
    import { LL } from "../../../i18n/i18n-svelte";
    import type { Game } from "../../Phaser/Game/Game";
    import type { SelectCompanionScene } from "../../Phaser/Login/SelectCompanionScene";
    import { SelectCompanionSceneName } from "../../Phaser/Login/SelectCompanionScene";
    import { collectionsSizeStore, selectedCollection } from "../../Stores/SelectCharacterSceneStore";
    import { analyticsClient } from "../../Administration/AnalyticsClient";
    import { IconChevronLeft, IconChevronRight } from "@wa-icons";

    interface Props {
        game: Game;
    }

    let { game }: Props = $props();

    let selectCompanionScene = $derived(game.scene.getScene(SelectCompanionSceneName) as SelectCompanionScene);

    /*function selectLeft() {
        selectCompanionScene.moveToLeft();
    }

    function selectRight() {
        selectCompanionScene.moveToRight();
    }*/

    function noCompanion() {
        selectCompanionScene.noCompagnion().catch((e) => console.error(e));
    }

    function selectCompanion() {
        selectCompanionScene.selectCompanion().catch((e) => console.error(e));
    }

    function selectLeftCollection() {
        selectCompanionScene.selectPreviousCompanionCollection();
    }

    function selectRightCollection() {
        selectCompanionScene.selectNextCompanionCollection();
    }

    function selectPrev() {
        selectCompanionScene.moveToLeft();
    }

    function selectNext() {
        selectCompanionScene.moveToRight();
    }
</script>

<!-- <div class="fixed z-0 top-0 left-0 w-full h-full backdrop-blur-sm" /> -->
<section
    class="text-center absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-[calc(50%+15vh)] h-16 p-0 m-0"
>
    <span class="text-4xl bold mobile:text-xl">
        {$LL.companion.select.title()}
    </span>
</section>
<div class="absolute w-full top-1/2 -translate-y-1/2 px-[10%] sm:px-[10%] md:px-[13%] lg:px-[20%] xl:px-0">
    <div class="btn-container flex justify-between xl:w-[700px] mx-auto">
        <button
            class="w-12 h-12 rounded-full flex justify-center items-center bg-mlight/80 shadow-light hover:bg-mlight-darker hover:shadow-light-hover"
            type="button"
            title="Влево"
            onclick={(event) => {
                event.preventDefault();
                selectPrev();
            }}
        >
            <IconChevronLeft class="text-lg text-mdark" />
        </button>
        <button
            class="w-12 h-12 rounded-full flex justify-center items-center bg-mlight/80 shadow-light hover:bg-mlight-darker hover:shadow-light-hover"
            type="button"
            title="Вправо"
            onclick={(event) => {
                event.preventDefault();
                selectNext();
            }}
        >
            <IconChevronRight class="text-lg text-mdark" />
        </button>
    </div>
</div>
<section class="category flex flex-row justify-center h-auto">
    {#if $collectionsSizeStore > 1 && $selectedCollection}
        <button
            class="light mr-2 selectCharacterButton"
            title="Влево"
            onclick={(event) => {
                event.preventDefault();
                selectLeftCollection();
            }}
        >
            <IconChevronLeft />
        </button>
        <strong class="category-text">{$selectedCollection}</strong>
        <button
            class="outline ml-2 selectCharacterButton"
            title="Вправо"
            onclick={(event) => {
                event.preventDefault();
                selectRightCollection();
            }}
        >
            <IconChevronRight />
        </button>
    {/if}
</section>
<div class="fixed bottom-0 w-full border border-solid border-t border-b-0 border-x-0 border-white/10">
    <section
        class="action m-auto p-4 flex flex-col-reverse md:flex-row items-center space-y-2 md:space-y-0 md:space-x-4 justify-center gap-2"
    >
        <button
            class="btn btn-secondary btn-lg btn-border w-full md:w-1/2 max-w-[400px] block selectCompanionSceneFormBack"
            onclick={(event) => {
                event.preventDefault();
                noCompanion();
            }}
        >
            {$LL.companion.select.any()}
        </button>
        <button
            type="submit"
            class="btn btn-secondary btn-lg w-full md:w-1/2 max-w-[400px] block selectCompanionSceneFormSubmit"
            onclick={(event) => {
                event.preventDefault();
                analyticsClient.trackAdminEvent("onboarding.companion_selected");
                selectCompanion();
            }}
        >
            {$LL.companion.select.continue()}
        </button>
    </section>
</div>

<!--<form class="selectCompanionScene">-->
<!--    <section class="text-center">-->
<!--        <h2 class="text-white text-2xl">{$LL.companion.select.title()}</h2>-->
<!--        {#if $collectionsSizeStore > 1 && $selectedCollection}-->
<!--            <button-->
<!--                class="outline mr-2 selectCompanionCollectionButton selectCharacterButtonLeft"-->
<!--                onclick|preventDefault={selectLeftCollection}-->
<!--            >-->
<!--                &lt;-->
<!--            </button>-->
<!--            <strong class="category-text">{$selectedCollection}</strong>-->
<!--            <button-->
<!--                class="outline ml-2 selectCompanionCollectionButton selectCompanionButtonRight"-->
<!--                onclick|preventDefault={selectRightCollection}-->
<!--            >-->
<!--                &gt;-->
<!--            </button>-->
<!--        {/if}-->
<!--        <button class="outline selectCharacterButton selectCharacterButtonLeft" onclick|preventDefault={selectLeft}>-->
<!--            &lt;-->
<!--        </button>-->
<!--        <button class="outline selectCharacterButton selectCharacterButtonRight" onclick|preventDefault={selectRight}>-->
<!--            &gt;-->
<!--        </button>-->
<!--    </section>-->
<!--    <section class="action flex flex-row justify-center">-->
<!--        <button class="outline mr-2 selectCompanionSceneFormBack" onclick|preventDefault={noCompanion}-->
<!--            >{$LL.companion.select.any()}</button-->
<!--        >-->
<!--        <button-->
<!--            type="submit"-->
<!--            class="light ml-2 selectCompanionSceneFormSubmit"-->
<!--            onclick|preventDefault={() => analyticsClient.trackAdminEvent("onboarding.woka_selected")}-->
<!--            onclick|preventDefault={selectCompanion}>{$LL.companion.select.continue()}</button-->
<!--        >-->
<!--    </section>-->

<!--</form>-->
<style>
    button {
        pointer-events: auto;
    }
    @media (min-width: 1921px) {
        .btn-container {
            width: 840px;
        }
    }
</style>
